import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from '../ui/Button';
import { AnimatedSection } from './AnimatedSection';
interface ReportPreviewSectionProps {
  onNavigate: (page: string) => void;
}
export function ReportPreviewSection({
  onNavigate
}: ReportPreviewSectionProps) {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-50" data-id="element-16564">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16565">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl" data-id="element-16566">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-16567">
            <div className="p-5 sm:p-10 lg:p-16 flex flex-col justify-center" data-id="element-16568">
              <span className="text-[10px] sm:text-xs font-bold text-indigo-300 uppercase tracking-[0.2em] mb-2 sm:mb-4" data-id="element-16569">
                Пример отчёта
              </span>
              <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-6 leading-tight" data-id="element-16570">
                Глубокая аналитика,
                <br data-id="element-16571" />а не общие фразы
              </h2>
              <p className="text-slate-400 text-xs sm:text-lg mb-4 sm:mb-8 leading-relaxed" data-id="element-16572">
                Наши авто-отчёты — это 30-40 страниц структурированной
                информации.
              </p>
              <ul className="space-y-2 sm:space-y-3 mb-5 sm:mb-10" data-id="element-16573">
                {['Графическая схема натальной карты', 'Анализ всех планет и домов', 'Практические советы'].map((t, i) => <li key={i} className="flex items-center text-slate-300 text-xs sm:text-sm" data-id="element-16574">
                    <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-400 mr-2 sm:mr-3 flex-shrink-0" data-id="element-16575" />{' '}
                    {t}
                  </li>)}
              </ul>
              <Button size="lg" variant="outline" className="w-fit bg-white border-0 hover:bg-slate-100 text-xs sm:text-sm" onClick={() => onNavigate('report-preview-natal')} data-id="element-16576">
                Посмотреть пример PDF
              </Button>
            </div>
            <div className="hidden sm:flex bg-slate-800/50 p-8 lg:p-12 items-center justify-center" data-id="element-16577">
              <motion.div animate={{
              y: [0, -8, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="w-full max-w-sm bg-white rounded-xl shadow-2xl p-8" data-id="element-16578">
                <div className="w-full h-28 bg-gradient-to-br from-indigo-50 to-slate-50 rounded-lg mb-6 flex items-center justify-center" data-id="element-16579">
                  <Star className="w-10 h-10 text-indigo-200" data-id="element-16580" />
                </div>
                <div className="w-3/4 h-3 bg-slate-200 rounded mb-3" data-id="element-16581" />
                <div className="w-1/2 h-3 bg-slate-100 rounded mb-6" data-id="element-16582" />
                <div className="space-y-2.5" data-id="element-16583">
                  <div className="w-full h-2 bg-slate-100 rounded" data-id="element-16584" />
                  <div className="w-full h-2 bg-slate-100 rounded" data-id="element-16585" />
                  <div className="w-5/6 h-2 bg-slate-50 rounded" data-id="element-16586" />
                  <div className="w-full h-2 bg-slate-100 rounded" data-id="element-16587" />
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}